import { tv } from 'tailwind-variants';

const styles = tv({
  base: ['flex', 'flex-wrap', 'gap-x-3', 'gap-y-1', 'text-blue-500'],
});

export default function Tags({ className, tags }) {
  if (!tags?.length) return null;

  return (
    <div className={styles({ class: className })}>
      {tags.map((tag) => (
        <span key={tag.id}>#{tag.name}</span>
      ))}
    </div>
  );
}
